export const AVALIABLE_GAME_SPEEDS = {
  NORMAL: 70,
  FAST: 85,
  FASTEST: 100
};
